module.exports = __webpack_public_path__ + "static/pattern1-0272c36c9e698bdf3aab4d95493e2c07.png";